import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { Icon } from "@material-ui/core";

import { app } from "js/namespaces";
import { Gap10 } from "js/react/components/Gap";
import { FlexBox } from "js/react/components/LayoutGrid";
import { stopPropagation } from "js/core/utilities/stopPropagation";
import { ToolTip } from "../../Components/ToolTip";

const IconButtonContainer = styled.div`
    margin: 0px 2px;
    opacity: 1;

    .MuiIcon-root {
        font-size: 17px !important;
        cursor: pointer;
        color: white;

        &:hover {
            color: #50bbe6 !important;
        }
    }

    &[disabled] {
        opacity: 0.3;

        .MuiIcon-root {
            cursor: default;
            color: white !important;
        }
    }
`;

export function UndoRedo({ onUndo, onRedo, canUndo, canRedo }) {
    return (
        <FlexBox onMouseDown={stopPropagation()} gap={5}>
            <ToolTip title="Undo" delay={1000}>
                <IconButtonContainer
                    onClick={onUndo}
                    disabled={!canUndo}
                >
                    <Icon>undo</Icon>
                </IconButtonContainer>
            </ToolTip>
            <ToolTip title="Redo" delay={1000}>
                <IconButtonContainer
                    onClick={onRedo}
                    disabled={!canRedo}
                >
                    <Icon>redo</Icon>
                </IconButtonContainer>
            </ToolTip>
        </FlexBox>
    );
}

export function UndoRedoWithUndoManager() {
    const [, setStackPosition] = useState(app.undoManager.stackPosition);
    const [, setUndoStack] = useState(app.undoManager.undoStack);

    useEffect(() => {
        app.undoManager.on("undo redo undoStackChanged", onStackChange);
        return () => {
            return app.undoManager.off("undo redo undoStackChanged", onStackChange);
        };
    }, []);

    const onStackChange = () => {
        setStackPosition(app.undoManager.stackPosition);
        setUndoStack(app.undoManager.undoStack);
    };

    const handleUndo = () => {
        app.undoManager.undo();
    };

    const handleRedo = () => {
        app.undoManager.redo();
    };

    return (
        <UndoRedo
            onUndo={handleUndo}
            onRedo={handleRedo}
            canUndo={app.undoManager.canUndo()}
            canRedo={app.undoManager.canRedo()}
        />
    );
}
